import { IonHeader, IonIcon, IonModal, IonText } from "@ionic/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { Content } from "@/components/content";
import { Toolbar } from "@/components/toolbar";
import { App } from "@/lib/capacitor/app";
import { xMarkIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ModalPushNotificationsDenied() {
  const { t } = useTranslation();
  const modalRef = useRef<HTMLIonModalElement>(null);
  const modal = useSelectorModalStore.use.pushNotificationsDenied();
  const present = useSelectorModalStore.use.present();
  const dismiss = useSelectorModalStore.use.dismiss();

  return (
    <IonModal
      ref={modalRef}
      isOpen={modal.isOpen}
      onWillPresent={() => present("pushNotificationsDenied")}
      onWillDismiss={() => dismiss("pushNotificationsDenied")}
      className=""
    >
      <IonHeader className="ion-no-border">
        <Toolbar className="ion-py-2">
          <Button
            slot="secondary"
            className="touch-target min-h-0 ion-bg-a-brand-300 ion-bg-f-brand-300 ion-bg-transparent ion-border-brand-300 ion-text-a-txt-primary ion-text-f-txt-primary ion-text-h-txt-primary ion-text-txt-primary ion-rounded-full ion-p-2 ion-border"
            onClick={() => modalRef.current?.dismiss()}
          >
            <IonIcon slot="icon-only" icon={xMarkIcon} className="size-5" />
          </Button>
        </Toolbar>
      </IonHeader>
      <Content inModal>
        <div className="txt-primary flex h-full flex-col gap-2">
          <IonText className="text-4xl font-bold">
            {t("common:settings.notifications.status.denied.title")}
          </IonText>

          <IonText className="text-balance text-base">
            {t("common:settings.notifications.status.denied.description")}
          </IonText>

          <Button
            expand="block"
            className="m-0 mt-auto h-12 ion-rounded-2xl part-native:text-md part-native:font-bold"
            onClick={async () => {
              await App.openSettings();
              modalRef.current?.dismiss();
            }}
          >
            {t("common:settings.notifications.status.denied.actions.open-settings")}
          </Button>
          <Button
            expand="block"
            slot="secondary"
            className="m-0 h-12 ion-bg-a-brand-300 ion-bg-f-brand-300 ion-bg-h-transparent ion-bg-transparent ion-border-brand-300 ion-text-a-txt-primary ion-text-f-txt-primary ion-text-h-txt-primary ion-text-txt-primary ion-rounded-2xl part-native:text-md part-native:font-bold"
            onClick={() => modalRef.current?.dismiss()}
          >
            {t("common:settings.notifications.status.denied.actions.dismiss")}
          </Button>
        </div>
      </Content>
    </IonModal>
  );
}
